import img1 from "./image1.png";
// import img2 from "./image2.png";

import Vision from "./Vision.png";
import Mission from "./Mission.png";

import icon1 from "./icon1.png";
import icon2 from "./icon2.png";
import icon3 from "./icon3.png";

export const Intro = [
  {
    title: "IG Agent",
    overlay: "Welcome To",
    para: "Built for real estate agencies of all sizes, IG AGENT CRM offers cutting edge sales process management, property management, and automation for real estate agents, real estate developers, and brokerage firms. Bring home more deals with the all-in-one real estate CRM platform that's crafted for your business.",
    type: "left",
    img: img1,
    id: "Intro",
  },
  // {
  //   title: "React JS",
  //   overlay: "Why frontend as",
  //   para: "I want to build your website using React JS as a frontend platform so that website UI will look better and user get the best experience which is the most important thing in market of ecommerce or store.",
  //   type: "right",
  //   img: Vi,
  //   id: "ReactJS",
  // },
];

export const About = [
  {
    title: "Vision",
    overlay: "What is our",
    para: "Real estate CRM software is a system that caters to the multiple requirements of real estate agents and real estate firms. From managing incoming requests, to preparing price quotes, to selling a property, the real estate CRM system takes care of the end-to-end process management for real estate agencies. With dynamic capabilities on both desktop and mobile, you'll have more time to concentrate on every deal on hand and grow your business.",
    img: Vision,
  },
  {
    title: "Mission",
    overlay: "What is our",
    para: "When it comes to real estate businesses, the way you engage your existing customers plays a crucial role in how you acquire future customers. Real estate is all about building trust, and it's no surprise that 82% of new property sales are referrals from either existing contacts, previous clients, family, friends, or relatives. Essentially, implementing a CRM software can work wonders for realtors by helping them manage their incoming leads, track interactions, and stay on top of important tasks.",
    img: Mission,
  },
];

export const Details = [
  {
    title: "Capture & Convert Leads",
    overlay: "Focus on Client Needs",
    para: "Swiftly move your leads through your sales pipeline using IG AGENT CRM's highly effective lead management features. Generate leads from webforms, website live chats, social media, or business cards, and push them into your IG AGENT CRM sales funnel. Automatically assign leads to sales reps using predefined workflow rules and use lead scoring to see which prospects your team needs to focus on.",
    img: Vision,
    type: "right",
  },
  {
    title: "Our Solution",
    overlay: "Point to be Noted",
    para: "Having a call centre or a CRM Department for this is utterly impractical. The solution lies in having a Mobile CRM. The entire CRM System in your smartphone is the need of an hour. The concept of Mobile CRMs might sound complicated but in reality, it is not. It does the following things.",
    type: "card",
    card: [
      {
        icon: icon1,
        title: "Audio Recordings",
        para: "Record Audio calls done between your agent and client to ensure feedbacks and responses.",
      },
      {
        icon: icon2,
        title: "Daily Callings",
        para: "You can achieve the target of engaging your client with your agent by assigning daily task to your client. Our system also help to manage incoming client callings as well.",
      },
      {
        icon: icon3,
        title: "Feedbacks and Responses",
        para: "Store customer data like Interests, Properties, Income Group, Demand, Desire etc. into a simple organised system",
      },
      {
        icon: icon1,
        title: "Easy Handling of Data",
        para: "Easily lets you filter important customers, by separating data of interested and not interested customers of yours.",
      },
      {
        icon: icon2,
        title: "Offers and Follow Ups",
        para: "Reach out to filtered lists via Calls to promote new offers and take follow ups.",
      },
      {
        icon: icon3,
        title: "Sales Representation",
        para: "Captures all the feedback given by your agent on your sales prospects.",
      },
    ],
  },
  {
    title: "Automated Selling & Blueprints",
    overlay: "Records and Reports",
    para: "Automate your follow up emails, IG AGENT CRM field updates, and notifications to give your sales reps time to close more deals. Use Blueprint's process automation capabilities to ensure everyone on your team follows the right sales process. Blueprint's built-in process reports help you identify and rectify bottlenecks in your processes.",
    img: Mission,
    type: "left",
  },
];

export const Terms = [
  {
    title: "Benefits & Improvements",
    overlay: "Sales Increments",
    para: "Manage your complete sales cycle from a unified IG AGENT CRM interface.",
    id: "Benefits-&-Improvements",
    img: null,
    points: [
      {
        listItem: "300% Improvement in lead conversion rates.",
      },
      {
        listItem: "41% Revenue increase per sales person.",
      },
      {
        listItem: "26% Improvement in customer retention rates.",
      },
      {
        listItem: "47% Increase in customer satisfaction rates.",
      },
    ],
  },
];
